{
  "name": "eb-ssms-service-portal",
  "version": "21.1.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-dev": "ng build --configuration development",
    "build-dev1": "ng build --configuration dev1",
    "build-sit": "ng build --configuration sit",
    "build-uat": "ng build --configuration uat",
    "build-uat2": "ng build --configuration uat2",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --no-watch --no-progress --browsers=ChromeHeadlessCI",
    "test:changed": "node scripts/test-changed-specs.js",
    "team:monitor": "node tools/ai-team-monitor/server.js",
    "team:monitor:test": "node --test tools/ai-team-monitor/server.test.js",
    "validate:changed": "node scripts/validate-changed-files.js",
    "lint": "ng lint --cache --cache-location .cache/eslint/.eslintcache && stylelint \"src/**/*.scss\" --fix --cache --cache-location .cache/stylelint/.stylelintcache",
    "format": "npx pretty-quick --staged",
    "format:staged": "npx pretty-quick --staged",
    "format:changed": "npx pretty-quick",
    "format:all": "npx prettier --write .",
    "format:check": "npx prettier --check .",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.20",
    "@angular/compiler": "21.2.20",
    "@angular/core": "21.2.20",
    "@angular/forms": "21.2.17",
    "@angular/google-maps": "21.2.14",
    "@angular/localize": "21.2.17",
    "@angular/material": "21.2.14",
    "@angular/material-moment-adapter": "21.2.14",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/router": "21.2.24",
    "@angular/service-worker": "21.2.17",
    "@azure/msal-angular": "^4.1.1",
    "@azure/msal-browser": "^4.30.0",
    "@cds/angular": "6.17.0",
    "@cds/core": "6.17.0",
    "@cds/ng-charts": "21.0.3",
    "@cds/ng-core": "21.0.3",
    "@cds/ng-data-table": "21.0.3",
    "@cds/ng-experimental": "21.0.3",
    "@cds/ng-themes": "21.0.3",
    "@cds/ng-web-components": "21.0.3",
    "@fortawesome/angular-fontawesome": "^0.10.0",
    "@fortawesome/fontawesome-svg-core": "^1.2.32",
    "@fortawesome/free-solid-svg-icons": "^5.15.1",
    "@kolkov/angular-editor": "2.1.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.0.0",
    "@ngx-loading-bar/core": "^6.0.0",
    "@ngx-loading-bar/router": "^6.0.0",
    "@ngx-progressbar/core": "^5.3.2",
    "@ngx-progressbar/http": "^5.3.2",
    "@ngxs/store": "^21.0.0",
    "@popperjs/core": "^2.9.2",
    "@swimlane/ngx-datatable": "^20.0.0",
    "@types/crypto-js": "^4.2.2",
    "@typescript-eslint/types": "^8.0.0",
    "@typescript-eslint/utils": "^8.0.0",
    "angular-calendar": "^0.29.0",
    "angular-gauge": "^4.0.0",
    "angular-svg-round-progressbar": "^15.0.0",
    "angular2-ladda": "^5.0.0",
    "angular2-signaturepad": "^4.0.2",
    "animate-sass": "^0.8.2",
    "big.js": "^6.2.1",
    "bootstrap": "^5.0.2",
    "chart.js": "^4.4.0",
    "cleave.js": "^1.6.0",
    "core-js": "^3.8.2",
    "crypto-js": "^4.2.0",
    "date-fns": "^2.29.3",
    "dompurify": "3.4.16",
    "flag-icon-css": "^3.5.0",
    "font-awesome": "^4.7.0",
    "ionicons": "^4.6.3",
    "ionicons-npm": "^2.0.1",
    "jquery": "^3.5.1",
    "jw-bootstrap-switch-ng2": "^2.0.5",
    "jwt-decode": "^3.1.2",
    "ladda": "^2.0.1",
    "linearicons": "^1.0.2",
    "loaders.css": "^0.1.2",
    "lodash-es": "^4.17.20",
    "luxon": "^3.0.1",
    "markdown-it": "15.0.3",
    "moment": "^2.30.1",
    "ng-multiselect-dropdown": "^0.2.14",
    "ng2-nouislider": "^1.8.2",
    "ngx-clipboard": "^15.0.1",
    "ngx-color-picker": "^11.0.0",
    "ngx-countup": "^7.3.3",
    "ngx-device-detector": "^10.0.0",
    "ngx-dropzone-wrapper": "^10.0.1",
    "ngx-image-cropper": "^3.3.3",
    "ngx-loading": "^16.0.0",
    "ngx-perfect-scrollbar": "^10.1.1",
    "ngx-select-dropdown": "^1.4.4",
    "ngx-textarea-autosize": "^2.0.3",
    "ngx-toastr": "^13.2.0",
    "ngx-trend": "^6.1.1",
    "ngx-ui-switch": "^15.0.0",
    "nouislider": "^14.6.3",
    "pe7-icon": "^1.0.4",
    "popper.js": "^1.16.0",
    "redux": "4.0.0",
    "rxjs": "~7.5.0",
    "signature_pad": "^2.3.2",
    "slick-carousel": "^1.8.1",
    "sweetalert2": "^7.22.0",
    "tslib": "^2.3.0",
    "@e965/xlsx": "0.20.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "~21.4.0",
    "@angular-eslint/eslint-plugin": "~21.4.0",
    "@angular-eslint/eslint-plugin-template": "~21.4.0",
    "@angular-eslint/schematics": "~21.4.0",
    "@angular-eslint/template-parser": "~21.4.0",
    "@angular/build": "21.2.17",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@angular/language-service": "21.2.17",
    "@fortawesome/fontawesome-free": "^5.11.2",
    "@types/big.js": "^6.1.6",
    "@types/jasmine": "~3.10.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/luxon": "^3.0.0",
    "@types/node": "^20.19.43",
    "@typescript-eslint/eslint-plugin": "^8.65.0",
    "@typescript-eslint/parser": "^8.65.0",
    "cross-env": "^5.2.1",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^8.5.0",
    "husky": "^8.0.1",
    "increase-memory-limit": "^1.0.7",
    "jasmine-core": "~4.0.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "lint-staged": "^13.0.3",
    "prettier": "^2.8.4",
    "pretty-quick": "^3.1.3",
    "redux-devtools-extension": "^2.13.8",
    "sass": "^1.32.4",
    "sonar-scanner": "^3.1.0",
    "stylelint": "^15.2.0",
    "stylelint-config-standard-scss": "^7.0.1",
    "ts-node": "~7.0.0",
    "typescript": "~5.9.3"
  },
  "overrides": {
    "@tootallnate/once": "2.0.1",
    "@babel/core": "7.29.7",
    "jsdom": "24.1.3",
    "@typescript-eslint/utils": {
      "brace-expansion": "5.0.12"
    }
  }
}
